import React,{useContext} from 'react';
import {useNavigate,useLocation} from 'react-router';
import {ListItem,ListItemButton,ListItemDecorator,ListItemContent} from '@mui/joy';
import FolderRoundedIcon from '@mui/icons-material/FolderRounded';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import {LayoutContext} from '../context';
import {hasStorage} from './pages';
import {closeSidebar} from '../utils';
export default function StorageNavItem(){
 const {account,setSidebarOpen}=useContext(LayoutContext),navigate=useNavigate(),location=useLocation();
 if(!hasStorage(account))return null;
 const active=location.pathname.startsWith('/storage');
 return <ListItem sx={{width:'100%'}}><ListItemButton variant="soft" color={active?'primary':'neutral'} aria-current={active?'page':undefined} sx={{borderRadius:'lg',px:2,lineHeight:1.1}} onClick={()=>{navigate('/storage');closeSidebar();setSidebarOpen(false);}}><ListItemDecorator><FolderRoundedIcon/></ListItemDecorator><ListItemContent>Хранилище</ListItemContent><KeyboardArrowRightRoundedIcon aria-hidden="true"/></ListItemButton></ListItem>;
}